import sendLog from '../../lib/sendLog'
import { checkSetAndGetSessionIdInClient } from '../../lib/checkSetAndGetSessionId'

const useThreatMetrix = () => {
  const orgId = process.env.THREATMETRIX_ORG_ID ?? ''
  const profileDomain = process.env.THREATMETRIX_PROFILE_DOMAIN ?? ''

  const initializeThreatMetrix = (sessionId: string) => {
    try {
      const persistentSessionId = checkSetAndGetSessionIdInClient(sessionId)
      window.threatmetrix.profile(
        profileDomain,
        orgId,
        persistentSessionId,
        undefined,
        window.threatmetrix.load_method.RUN_IMMEDIATE
      )
    } catch (error) {
      sendLog(error as Error)
    }
  }
  return initializeThreatMetrix
}
export default useThreatMetrix
